module.exports = __webpack_public_path__ + "static/media/thumbnail.0b51b341.png";